import { paramsToString } from '@/services/http/httpClient'
import billmaHttpClient from '@/services/http/billmaHttpClient'
import publicHttpClient from '@/services/http/publicHttpClient'

export const apiGetSendOtp = (encSinisterId) => {
  const params = new URLSearchParams()
  params.append('sinisterId', encSinisterId)
  return billmaHttpClient.get(`selfcare/otp${paramsToString(params)}`)
}

export const apiPostValidateOtp = (sinisterId, otp, renew) => {
  otp = Number(otp)
  let body
  if (renew) {
    body = { sinisterId, otp, renew: renew }
  } else {
    body = { sinisterId, otp }
  }
  return billmaHttpClient.post('selfcare/otp', body)
}

export const apiPostSsoCallback = (sinisterId, code, redirectUri) => {
  return billmaHttpClient.post('selfcare/sso/callback', { sinisterId, code, redirectUri })
}

export const apiGetUser = () => {
  const token = sessionStorage.getItem('mavAuth')

  if (!token) throw Error('token not found in session storage')

  const headers = { Authorization: token }

  return publicHttpClient.get('api-token-auth/user/', { headers })
}

export const apiGetUserSettings = (sinisterId) => {
  const token = sessionStorage.getItem('mavAuth')
  const headers = { Authorization: token }
  return publicHttpClient.get(`sinister/user?sinister_id=${sinisterId}`, {
    headers
  })
}
